import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
//import { AddressInfo, TableDocTypes } from 'src/app/entities/various';
import { Anagrafica, ManagedUsersTable } from 'src/app/entities/various';
import { LoginService, UserData, UserInfo } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-ricerca-rivenditori',
  templateUrl: './ricerca-rivenditori.component.html',
  styleUrls: ['./ricerca-rivenditori.component.css']
})
export class RicercaRivenditoriComponent implements OnInit {

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  searchFilter : string = "json_sdi_data";
  titleSearch: string = "";

  loading : boolean = false;
  first: boolean = true;
  managedUsersTable : ManagedUsersTable | undefined;

  previousPage : number = 1;
  nextPage : number = 1;
  currentPage : number = 1;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, private userService: UserService) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
  }

  close(){
    this.activeModal.close(null);
  }

  search(event: any){
    if(this.titleSearch.length < 3 ) return;
    if(!event || event.keyCode == 13){
      this.retriveList();
    }
  }

  private async retriveList(){
    this.loading = true;
    //this.managedUsersTable = [];
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    let params = new HttpParams();
    params = params.append('endRow', 0);
    params = params.append('lastKeyVal', '');
    params = params.append('page', this.currentPage);
    params = params.append('pageDirection', 'FORWARD');
    params = params.append('pageSize', 10);
    params = params.append('pagination', true);
    params = params.append('paginationMode', 'SKIP');
    
    params = params.append('searchFilter', '{\"role\":\"R\",\"' + this.searchFilter + '\":\"' + this.titleSearch + '\"}');
    params = params.append('sortDir', 'ASC');
    //params = params.append('sortKey', this.searchFilter);
    params = params.append('startRow', 1);
    params = params.append('totalPages', 0);
    params = params.append('totalRows', 0);
    
    let response = await this.userService.getManagedUsersTable(userInfo!.user_id, params);
    if(response.success){
      let table : ManagedUsersTable = response.data as ManagedUsersTable;
      if((table.totalPages!= this.currentPage ) && (table.totalPages > this.nextPage ))
                this.nextPage=table.totalPages;
      this.managedUsersTable = table;
    }
    this.first = false;
    this.loading = false;
  }

  getJsonData(u : UserInfo) {
    let jdata : Anagrafica =  JSON.parse(u.json_sdi_data);
    return jdata;
  }
    

  prev(){
    this.currentPage=this.currentPage-1;
    this.retriveList();
  }

  next(){
    this.currentPage=this.currentPage+1;
    this.retriveList();
  }




  public selectOne(username: any){
    this.activeModal.close(username);
  }

}
